import { ABI, SamplePack } from '@arpeggi/shared'
import { ethers } from 'ethers'
import moment from 'moment'
import { useUGCContractMetadata } from '../../web3-utils'
import { saleIsLive } from '../utils'
import { usePriceCardState } from './usePriceCardState'

export const CRITERIA_SP_ID = 24

const getEthPrice = (sp: SamplePack, isPresale: boolean): string => {
  const presaleFree = !sp.edition?.preSalePrice || sp.edition?.preSalePrice === '0'
  const publicSaleFree = !sp.edition?.price || sp.edition?.price === '0'

  if (presaleFree || publicSaleFree) return 'FREE'
  if (isPresale) return ethers.utils.formatEther(sp.edition.preSalePrice)
  return ethers.utils.formatEther(sp.edition.price)
}

export const usePriceCard = (sp: SamplePack, isPresale: boolean) => {
  const state = usePriceCardState(sp, isPresale)
  const { totalMinted, mint, isMinting } = useUGCContractMetadata({
    contractAddress: sp?.edition?.contractAddress,
    abi: ABI.legacy.ERC721Generic_11_21_22,
    chain: sp?.edition?.chain
  })

  const ethPrice = getEthPrice(sp, isPresale)
  const saleLive = saleIsLive(sp, isPresale)

  let volume = sp.edition?.totalVolume <= 0 ? '∞' : sp.edition?.totalVolume
  // if the mint has finished, we want to show the number minted as the volume
  if (state.mintHasExpired && volume === '∞') {
    volume = totalMinted
  }

  const endIsSoon =
    Math.abs(
      moment().diff(
        moment(isPresale ? sp?.edition?.preSaleEndTime : sp?.edition?.publicSaleEndTime),
        'days'
      )
    ) <= 30 // a boolean representing whether the mint ends within the next month

  const showCommercialLicenseCopy = sp.id === CRITERIA_SP_ID

  return {
    totalMinted,
    mint,
    isMinting,
    ethPrice,
    volume,
    showCommercialLicenseCopy,
    endIsSoon,
    saleLive,
    ...state
  }
}
